/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 */
import api from '@/lib/api';

/** Fase 23 — AI Team di cura: punteggio di declino e aggiornamento per i familiari. */

export const getCareAiReports = (teamId, kind) =>
  api.get(`/care-team/${teamId}/ai/reports`, { params: kind ? { kind } : {} }).then((r) => r.data);

export const generateDeclineScore = (teamId, { days = 14, scales = [] } = {}) =>
  api.post(`/care-team/${teamId}/ai/decline-score`, { days, scales }).then((r) => r.data);

export const generateFamilyUpdate = (teamId, { shift_notes, days = 1 } = {}) =>
  api.post(`/care-team/${teamId}/ai/family-update`, { shift_notes: shift_notes || null, days }).then((r) => r.data);

export const RISK_META = {
  1: { label: 'Stabile', cls: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300 border-emerald-500/30' },
  2: { label: 'Attenzione', cls: 'bg-lime-500/15 text-lime-700 dark:text-lime-300 border-lime-500/30' },
  3: { label: 'Moderato', cls: 'bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-500/30' },
  4: { label: 'Elevato', cls: 'bg-orange-500/15 text-orange-700 dark:text-orange-300 border-orange-500/30' },
  5: { label: 'Critico', cls: 'bg-destructive/15 text-destructive border-destructive/30' },
};

export const riskMeta = (level) => RISK_META[level] || { label: 'Non determinato', cls: 'bg-secondary text-muted-foreground border-border' };
